export default "__VITE_ASSET__BIACENSt__"